var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-hcaptcha',{ref:"captcha",attrs:{"sitekey":"f792226a-0434-473e-8356-fbcc85c8ab5e"},on:{"verify":_vm.verified,"expired":_vm.expired,"open":_vm.opened}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }